<template>
  <v-container>
    <v-select
      v-model="teacherId"
      :items="teacherList"
      item-value="id"
      item-text="name"
      :label="label"
      :name="filedName"
      :menu-props="{ closeOnClick: true, closeOnContentClick: true }"
    >
      <template v-slot:selection="{ item }">
        <v-list-item
          @click="
            teacherId = item.id
            $emit('change')
          "
        >
          <v-list-item-avatar>
            <v-img :src="item.image.url"></v-img>
          </v-list-item-avatar>
          <v-list-item-content v-text="item.name"></v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item
          @click="
            teacherId = item.id
            $emit('change')
          "
        >
          <v-list-item-avatar>
            <v-img :src="item.image.url"></v-img>
          </v-list-item-avatar>
          <v-list-item-content v-text="item.name"></v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:append-item>
        <v-list-item>
          <v-dialog
            max-width="600px"
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="dialog"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="text-center"
                rounded
                dark
                color="secondary"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>add</v-icon>
              </v-btn>
            </template>
            <Teacher
              :is-edit="false"
              @tecaher-update="teacherHook"
              @teacher-create="teacherHook"
              @cancel="dialog = false"
            >
            </Teacher>
          </v-dialog>
        </v-list-item>
      </template>
    </v-select>
  </v-container>
</template>

<script>
import Teacher from '@/components/hps/Teacher'

export default {
  name: 'TeacherSelect',
  components: { Teacher },
  props: {
    label: { type: String, default: 'Преподаватель' },
    filedName: { type: String, default: 'teacher_id' },
    teacher: { type: Object, required: false, default: () => {} },
    fieldRules: {
      type: Array,
      default: function () {
        return this.rules
      },
    },
  },
  data() {
    return {
      dialog: false,
      teacherList: [],
      loading: false,
      teacherId: '',
    }
  },
  watch: {
    teacher() {
      this.teacherId = this.teacher
    },
    teacherId() {
      this.$emit('teacher-id-selected', this.teacherId)
    },
  },
  mounted() {
    this.updateData()
  },
  methods: {
    teacherHook(teacher) {
      this.teacherId = teacher.id
      this.dialog = false
      this.updateData()
    },
    updateData() {
      this.loading = true
      this.axios({
        url: '/v1/hps/teachers',
        method: 'get',
      })
        .then((res) => {
          this.teacherList = res.data || []
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
